
/* Shopify API */
"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format=Theme.moneyFormat||"${{amount}}",Shopify.formatMoney=function(t,e){function n(t,e){return void 0===t?e:t}function o(t,e,o,i){if(e=n(e,2),o=n(o,","),i=n(i,"."),isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+o)+(r[1]?i+r[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var i="",r=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(r)[1]){case"amount":i=o(t,2);break;case"amount_no_decimals":i=o(t,0);break;case"amount_with_comma_separator":i=o(t,2,".",",");break;case"amount_with_space_separator":i=o(t,2," ",",");break;case"amount_with_period_and_space_separator":i=o(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=o(t,0,".",",");break;case"amount_no_decimals_with_space_separator":i=o(t,0," ");break;case"amount_with_apostrophe_separator":i=o(t,2,"'",".")}return a.replace(r,i)},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);return null!==e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|webp|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null==o)return null;var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.onError=function(t,e){var data = eval('(' + t.responseText + ')');
alert(data.message + '(' + data.status  + '): ' + data.description)}

/*! js-cookie v3.0.5 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));


if (!customElements.get('adev-quantity-selector')) {
	customElements.define('adev-quantity-selector', class adevQuantitySelector extends HTMLElement {
		constructor() {
			super();
		}

		increase() {
			const max = this.inputEl.getAttribute('max') ? parseInt(this.inputEl.getAttribute('max')) : 1000000;
			const min = this.inputEl.getAttribute('min') ? parseInt(this.inputEl.getAttribute('min')) : 1;

			let currentValue = parseInt(this.inputEl.value) || min;

			if (currentValue < max) {
				currentValue++;
				this.inputEl.value = currentValue;
				this.inputEl.dispatchEvent(new Event('change'));

				this.dispatchEvent(new CustomEvent('adev:quantity:changed', { detail: currentValue }));
			}
		}
		
		decrease() {
			const min = this.inputEl.getAttribute('min') ? parseInt(this.inputEl.getAttribute('min')) : 1;
			let currentValue = parseInt(this.inputEl.value) || min;

			if (currentValue > min) {
				currentValue--;
				this.inputEl.value = currentValue;
				this.inputEl.dispatchEvent(new Event('change'));

				this.dispatchEvent(new CustomEvent('adev:quantity:changed', { detail: currentValue }));
			}
		}

		connectedCallback() {
			this.inputEl = this.querySelector('[data-adev-quantity-selector="value"]');
			if (!this.inputEl) return;

			this.querySelectorAll('[data-adev-quantity-selector="up"]').forEach( button => {
				button.addEventListener('click', this.increase.bind(this));
			});

			this.querySelectorAll('[data-adev-quantity-selector="down"]').forEach( button => {
				button.addEventListener('click', this.decrease.bind(this));
			});
		}

		disconnectedCallback() {
			this.querySelectorAll('[data-adev-quantity-selector="up"]').forEach( button => {
				button.removeEventListener('click', this.increase.bind(this));
			});

			this.querySelectorAll('[data-adev-quantity-selector="down"]').forEach( button => {
				button.removeEventListener('click', this.decrease.bind(this));
			});
		}

	});
}

if (!customElements.get('adev-overlay')) {
    customElements.define('adev-overlay', class adevOverlay extends HTMLElement {
        constructor() {
            super();
        }

        isOpened() {
            return this.classList.contains('is--active');
        }

        open() {
            this.classList.add('is--active');
        }

        close() {
            this.classList.remove('is--active');
        }

        onClick() {
            const cartDrawer = document.querySelector('adev-cart-drawer');
            if (cartDrawer?.classList.contains('is--loading')) return;

            if (this.isOpened()) {
                this.close();
            } else {
                this.open();
            }

            this.dispatchEvent(new CustomEvent('overlay-click', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('adev:overlay-click', { bubbles: true }));
        }

        connectedCallback() {
            document.addEventListener('adev:open-overlay', this.open.bind(this));
            document.addEventListener('adev:close-overlay', this.close.bind(this));

            this.addEventListener('click', this.onClick.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.onClick.bind(this));
        }

    });
}

if (!customElements.get('adev-video-tag')) {
	customElements.define('adev-video-tag', class adevVideoTag extends HTMLElement {
		constructor() {
			super();

			this.autoplay = this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay') === 'true';

			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						if(this.autoplay) {
							this.togglePlay();
						} else {
							this.initVideo();
						}

						observer.unobserve(this);
					}
				});
			});

			observer.observe(this);
			
		}

		initVideo(){
			this.video = this.querySelector('video');

			if(!this.video) {
				const scriptEl = this.querySelector('script');

				this.innerHTML += scriptEl.innerHTML;
				this.video = this.querySelector('video');

				this.setVideoEventListeners();
			}
		}

		togglePlay(){
			this.initVideo();

			if (this.video.paused) {
				this.video.play();
			} else {
				this.video.pause();
			}
		}

		play(){
			this.initVideo();
			this.video.play();
		}

		pause(){
			this.initVideo();
			this.video.pause();
		}

		mute(){
			this.initVideo();
			this.video.muted = true;
		}

		unmute(){
			this.initVideo();
			this.video.muted = false;
		}

		toggleMute() {
			this.initVideo();

			if (this.video.muted) {
				this.video.muted = false;
			} else {
				this.video.muted = true;
			}
		}

		setVideoEventListeners(){
			this._onVideoMuted();

			this.video.addEventListener('play', this._onVideoPlay.bind(this));
			this.video.addEventListener('pause', this._onVideoPause.bind(this));
			this.video.addEventListener('volumechange', this._onVideoMuted.bind(this));

			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			if (playButton) {
				playButton.addEventListener('click', this.togglePlay.bind(this));
			}

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			if (toggleMuteButton) {
				toggleMuteButton.addEventListener('click', this.toggleMute.bind(this));
			}

			this.addEventListener('touchstart', () => this._handleTouchStart());
			this.addEventListener('touchend', () => this._handleTouchEnd());
		}

		_onVideoPlay() {
			this.classList.add('adev--is-revealed');
			this.classList.add('adev--is-playing');
		}

		_onVideoPause() {
			this.classList.remove('adev--is-playing');
		}

		_onVideoMuted() {
			if (this.video.muted) {
				this.classList.add('adev--is-muted');
			} else {
				this.classList.remove('adev--is-muted');
			}
		}

		_handleTouchStart() {
			this.classList.add('adev--is-touching');
			clearTimeout(this._handleTouchStartTimeout);
		}

		_handleTouchEnd() {
			this._handleTouchStartTimeout = setTimeout(() => {
				this.classList.remove('adev--is-touching');
			}, 1000);
		}

		connectedCallback() {
		}

		disconnectedCallback() {
			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			if (playButton) {
				playButton.removeEventListener('click', this.togglePlay.bind(this));
			}

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			if (toggleMuteButton) {
				toggleMuteButton.removeEventListener('click', this.toggleMute.bind(this));
			}

			if (this.video) {
				this.video.removeEventListener('play', this._onVideoPlay.bind(this));
				this.video.removeEventListener('pause', this._onVideoPause.bind(this));
				this.video.removeEventListener('volumechange', this._onVideoMuted.bind(this));
			}

			this.removeEventListener('touchstart', () => this._handleTouchStart());
			this.removeEventListener('touchend', () => this._handleTouchEnd());
		}

	});
}


window.adev = window.adev || {};


window.adev.Utils = Object.assign({

	debounce(callback, delay = 300) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				callback.apply(this, args);
			}, delay);
		};
	}

}, window.adev.Utils);